module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ui right floated link header"
  }, _vm._l((_vm.areas), function(a) {
    return _c('router-link', {
      key: a.name,
      attrs: {
        "to": a.path
      }
    }, [_vm._v("\n            " + _vm._s(a.name) + "\n        ")])
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "ui left floated title header"
  }, [_c('span', {
    staticClass: "ui mini image"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/Wikimedia-logo.svg")
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Wikimedia Statistics")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-7b9d7b33"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TopNav.vue
// module id = 393
// module chunks = 1